const {
  required,
  maxLength,
  email,
  helpers,
} = require("vuelidate/lib/validators");

const getValidations = () => {
  return {
    panel: {
      name: {
        required,
        maxLength: maxLength(128),
        alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
      },
      email: {
        required,
        email,
        alpha: helpers.regex("alpha", /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/),
        maxLength: maxLength(64),
      },
      phoneNumber: {
        required,
        alpha: helpers.regex("alpha", /^\d{7,10}$/),
      },
    },
    aoeoptiontags: {
      required,
    },
    skilloptionstag: {
      required,
    },
  };
};

module.exports = {
  getValidations,
};
